<template>
  <div class="table-exchange-rate">
    <div v-if="item.exchangeRate" class="items-flex">
      <div v-if="item.customExchangeRate || item.exchangeRate !== 1">
        <v-tooltip top max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" class="items-flex" v-on="on">
              <currency neverHide :value="item.exchangeRate" :decimals="3" />
              <v-avatar v-if="item.customExchangeRate" size="7" color="accentYellow" class="ml-1" />
              <v-avatar v-else size="7" color="primary" class="ml-1" />
            </div>
          </template>
          <span v-if="item.customExchangeRate">
            {{ $t('views.common.tableExchangeRate.customExchangeRate') }}
          </span>
          <span v-else>{{ $t('views.common.tableExchangeRate.filiosExchangeRate') }}</span>

          <span v-if="type === 'dividend'">
            {{ `${item.currency}/${user.baseCurrency}` }}
          </span>
          <span v-else-if="item.position && item.position.currency">
            {{ `${item.position.currency}/${user.baseCurrency}` }}
          </span>
        </v-tooltip>
      </div>
      <div v-else>
        <currency neverHide :value="item.exchangeRate" :decimals="3" />
      </div>
    </div>
    <WarningIcon v-else :text="$t('views.common.tableExchangeRate.addExchangeRate')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Currency from '@/views/components/common/Currency.vue'
import WarningIcon from '@/views/components/common/WarningIcon.vue'

export default {
  components: { Currency, WarningIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss">
.table-exchange-rate {
  .items-flex {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
